import JobSearch from "../../../../component/jobSearch";
import{ memo } from "react";

const HomeJobSearchPage = () =>{
    return (
        <JobSearch/>
    );
}

export default memo(HomeJobSearchPage);